import ClarityWeb from '@microsoft/clarity';
import config from 'config/config';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import { useContext, useEffect } from 'react';
import { useAppConfigStore } from 'stores/appConfigStore';
import { showFeatureFlag } from 'utils/featureFlagUtils';
import { useUiStore } from 'stores/uiStore';

const projectID = config.clarityProjectId;

const Clarity = () => {
  const screenName = useAppConfigStore((state) => state.currentRoute)?.name;
  const modalName = useUiStore((state) => state.sheetModal);
  const {
    flags: { clarity },
  } = useContext(FeatureFlagsContext);
  const enableClarity = showFeatureFlag(clarity);

  useEffect(() => {
    if (projectID && enableClarity) {
      ClarityWeb.init(projectID);
    }
  }, [enableClarity]);

  useEffect(() => {
    if (enableClarity && screenName) {
      ClarityWeb.setTag('screen', screenName);
    }
  }, [screenName, enableClarity]);

  useEffect(() => {
    if (enableClarity && modalName) {
      ClarityWeb.event(`modal_opened_${modalName}`);
    }
  }, [modalName, enableClarity]);

  return null;
};

export default Clarity;
